/**
 * Bouton « Retour en haut » pour les longues pages documentaires (CGV, etc.).
 * Progressive enhancement : lien d'ancre fonctionnel sans JS.
 * Le bouton se décale au-dessus du footer lorsqu'il entre dans le viewport.
 */
export function initBackToTop(): void {
  const button = document.querySelector<HTMLAnchorElement>('[data-back-to-top]');
  if (!button) {
    return;
  }

  const footer = document.querySelector<HTMLElement>('.site-footer');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const threshold = 400;
  const gapPx = 16;

  const update = (): void => {
    const visible = window.scrollY > threshold;
    button.hidden = !visible;

    if (!footer) {
      button.style.bottom = '';
      return;
    }

    const footerTop = footer.getBoundingClientRect().top;
    const viewportHeight = window.innerHeight;

    if (footerTop < viewportHeight) {
      const overlap = viewportHeight - footerTop;
      button.style.bottom = `${overlap + gapPx}px`;
    } else {
      button.style.bottom = '';
    }
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });

  button.addEventListener('click', (event) => {
    event.preventDefault();
    const target = document.getElementById('contenu');
    target?.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start',
    });
  });
}
